import { DsImage, DsTypography } from '@ice-web-app/designSystem';
import { useTranslation } from '@ice-web-app/shared-hooks';
import { useCurrentUserStore } from '@ice-web-app/shared-store';
import { Box, Stack } from '@mui/material';
import { Dispatch, FC, SetStateAction, useEffect, useRef, useState } from 'react';
import SidebarIconFrame from '../SidebarIconFrame';
import MicroSystemMenu from './MicroSystemMenu';

interface Props {
  menu: 'ecosystem' | 'microSystem' | 'member' | 'none';
  setMenu: Dispatch<SetStateAction<'ecosystem' | 'microSystem' | 'member' | 'none'>>;
}

const MicroSystem: FC<Props> = ({ menu, setMenu }) => {
  const { t } = useTranslation();
  const ref = useRef(null);
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
    setMenu('microSystem');
  };
  const { currentMicroSystem } = useCurrentUserStore();

  useEffect(() => {
    if (menu === 'microSystem') setAnchorEl(ref.current);
  }, [menu]);

  return (
    <>
      <Stack justifyContent="center" alignItems="center" gap={3.25}>
        <Box ref={ref}>
          <SidebarIconFrame handleClick={handleClick}>
            <DsImage
              imgUrl={currentMicroSystem?.logo}
              alt={currentMicroSystem?.name}
              width={42}
              height={42}
              sx={{ zIndex: 9, p: 1, cursor: 'pointer' }}
            />
          </SidebarIconFrame>
        </Box>

        <DsTypography variant="body2_500" sx={{ fontSize: '0.625rem', textAlign: 'center' }}>
          {t('LABEL_MICROSYSTEM', {
            label: currentMicroSystem?.name || '',
          })}
        </DsTypography>
      </Stack>
      <MicroSystemMenu anchorEl={anchorEl} setAnchorEl={setAnchorEl} setMenu={setMenu} />
    </>
  );
};
export default MicroSystem;
